import { TrendingFeedPost } from "components";
import FeedLayout from "layouts/files/FeedLayout";
import { useState } from "react";
import { MapPagesHeader } from "ui";

const HashtagMap = () => {
    const [filter, setFilter] = useState("");
    return (
        <FeedLayout pageTitle="map">
            <div className="maps-pages">
                <MapPagesHeader
                    title="#Hashtag"
                    filterVal={filter}
                    setFilterVal={setFilter}
                />
                <TrendingFeedPost hashtag="demoHashtag1" />
                <TrendingFeedPost
                    hashtag="demoHashtag2"
                    text="please choose between the two options"
                    mediaType={8}
                />
                <TrendingFeedPost hashtag="demoHashtag3" mediaType={5} />
                <TrendingFeedPost hashtag="demoHashtag4" mediaType={9} />
            </div>
        </FeedLayout>
    );
};

export default HashtagMap;
